import { render, staticRenderFns } from "./TaskTree.vue?vue&type=template&id=2d8de130&scoped=true"
import script from "./TaskTree.vue?vue&type=script&lang=js"
export * from "./TaskTree.vue?vue&type=script&lang=js"
import style0 from "./TaskTree.vue?vue&type=style&index=0&id=2d8de130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8de130",
  null
  
)

export default component.exports